'use client';

import { getIsMobile } from '@/libs/utils/user';
import * as S from './styles';

const Benefit = () => {
  const isMobile = getIsMobile();
  if (isMobile) return;

  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const benefitList: string[] = ['통합대시보드', '리뷰수집', 'AI 자동답변', '빠른대응', '인사이트 분석'];

  const getBenefitRender = (text: string, index: number) => {
    return (
      <S.Benefit key={`enterprise-benefit-${index}`}>
        {(index === 2 || index === 4) && <S.Icon src={baseImageUrl + '/landing/enterprise/icon-ai.svg'} alt={'아이콘 이미지'} width={24} height={24}></S.Icon>}
        {text}
      </S.Benefit>
    );
  };

  return (
    <S.Container>
      <S.Inner>
        <S.BenefitList>
          {benefitList.map((benefit, index) => {
            return getBenefitRender(benefit, index);
          })}
        </S.BenefitList>
      </S.Inner>
    </S.Container>
  );
};

export default Benefit;
